/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ObjectInstance} from "../models/object-instance";
import {ObjectService} from "../services/object.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class DeviceInstancesResolver implements Resolve<ObjectInstance[]> {

  constructor(
    private mObjectService: ObjectService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ObjectInstance[]> {
    try {
      return await this.mObjectService.getAllDeviceObjectInstances();
    } catch (error) {
      console.error("Problem resolving Device Instances... Error: " + error, error);
    }
  }

}
